var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userIsTalent
      ? _c("h2", [_vm._v("My Activity")])
      : _c("h2", [_vm._v(_vm._s(_vm.$starLabel) + " Activity\n  ")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._l(_vm.statList, function (stat) {
          return _c("metric-card", {
            key: stat.name,
            attrs: { metric: stat, "style-options": "col-sm-4" },
          })
        }),
        _vm._v(" "),
        _vm.$userIsAdmin && _vm.showAll && _vm.$vlastMode
          ? _c(
              "div",
              { staticClass: "col-sm-4" },
              [
                _c("label", [
                  _vm._v("Filter stats by " + _vm._s(_vm.$t("Category"))),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  key: "category",
                  staticClass: "selectize selectize-single",
                  attrs: { name: "category_id", options: _vm.categoryOptions },
                  model: {
                    value: _vm.category_id,
                    callback: function ($$v) {
                      _vm.category_id = $$v
                    },
                    expression: "category_id",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "a",
        {
          staticClass: "pull-right",
          staticStyle: {
            cursor: "pointer",
            padding: "0px 20px 20px 20px",
            display: "inline-flex",
            "align-items": "center",
          },
          on: { click: _vm.toggleShowAll },
        },
        [
          _vm.showAll
            ? _c("i", { staticClass: "fa fa-2x fa-caret-up" })
            : _vm._e(),
          _vm.showAll ? _c("span", [_vm._v("  Show Less")]) : _vm._e(),
          _vm._v(" "),
          !_vm.showAll
            ? _c("i", { staticClass: "fa fa-2x fa-caret-down" })
            : _vm._e(),
          !_vm.showAll ? _c("span", [_vm._v("  Show More")]) : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }